import sentry from 'src/js/modules/analytics/sentry';

const reportTranslationError = ({ error, flow, locale, pageIds }) => {
  // eslint-disable-next-line no-console
  console.error(error);
  sentry.instance.captureException(error, {
    flow,
    locale,
    pageIds,
    errorCode: error?.results?.code ?? null,
  });
};

export default reportTranslationError;
